/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WalletControllerDtoDepositAddressRequest model module.
 * @module model/WalletControllerDtoDepositAddressRequest
 * @version 1.0
 */
class WalletControllerDtoDepositAddressRequest {
    /**
     * Constructs a new <code>WalletControllerDtoDepositAddressRequest</code>.
     * @alias module:model/WalletControllerDtoDepositAddressRequest
     */
    constructor() { 
        
        WalletControllerDtoDepositAddressRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoDepositAddressRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoDepositAddressRequest} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoDepositAddressRequest} The populated <code>WalletControllerDtoDepositAddressRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoDepositAddressRequest();

            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoDepositAddressRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoDepositAddressRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} walletNo
 */
WalletControllerDtoDepositAddressRequest.prototype['walletNo'] = undefined;






export default WalletControllerDtoDepositAddressRequest;

